<script>
import { Line, mixins } from 'vue-chartjs'
const { reactiveProp } = mixins

export default {
  extends: Line,
  mixins: [reactiveProp],
  // props: ['chartData','options'],
  
  data: () => ({
    options: {
      // RWD
      responsive: true,
      maintainAspectRatio: false,
      legend: {
        position: 'bottom',
        labels: {
          fontColor: 'rgb(52, 58, 64)',
        }
      },
    }
  }),
  mounted() {
    this.chartRender()
  },
  methods: {
    chartRender() {
      this.renderChart(this.chartData, this.options)
    }
  }
}
</script>